import * as React from 'react';

import AccordionTextWithSubtextItem from 'components/AccordionBodyItem/AccordionTextWithSubtextItem';
import AvatarWithTextItem from 'components/AvatarWithTextItem';
import AvatarWithTextItems from 'components/AvatarWithTextItems';
import Coin from 'components/Coin';
import LayerTrigger from 'components/LayerTrigger';
import Link from 'components/Link';
import Tooltip from 'components/Tooltip';
import HoverLayerTrigger from 'components/HoverLayerTrigger';
import UserAvatar from 'users/components/UserAvatar';
import UserLink from 'users/components/UserLink';
import CurrentUser from 'auth/CurrentUser';
import { OrganizationRole } from 'globalTypes';
import type { ReachabilityInfo } from 'components/ReachabilityBadge';
import type { ContactabilityStatus } from 'globalTypes';

type Props = {
  familySummary: any;
  maxProfilePics: number;
  orientation: 'horizontal' | 'vertical';
  staticProfilePicture?: boolean;
  onFamilyMemberClick?: Function;
};

export default class GroupMemberFamilyList extends React.Component<Props> {
  static defaultProps = {
    maxProfilePics: 5,
    orientation: 'horizontal',
  };

  hasProfileRefresh() {
    const currentUser = CurrentUser.getUser();
    return currentUser && currentUser.hasFeature('profile_refresh.web.5-5');
  }

  renderProfilePicture = (familyMember: {
    id: number;
    name: string;
    uuid: string;
    initials: string;
    profilePictureUrl?: string | null;
    contactabilityStatus?: ContactabilityStatus;
    reachabilityInfo?: ReachabilityInfo;
  }) => {
    const { staticProfilePicture, onFamilyMemberClick } = this.props;
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    const profilePicture = <UserAvatar user={familyMember} size="medium" />;

    if (staticProfilePicture) {
      return (
        <LayerTrigger
          key={familyMember.id}
          layer={<Tooltip>{familyMember.name}</Tooltip>}
          placement="bottom"
          alignment="middle"
        >
          <Link
            onClick={(event) => {
              event.stopPropagation();
              if (onFamilyMemberClick) {
                onFamilyMemberClick(familyMember);
              }
            }}
          >
            {profilePicture}
          </Link>
        </LayerTrigger>
      );
    }

    return (
      <UserLink
        userId={familyMember.id}
        key={familyMember.id}
        placement="bottom"
        alignment="left"
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        block="inline"
      >
        {profilePicture}
      </UserLink>
    );
  };

  renderVerticalFamilyMembersGroup = (
    familyMembers: any[],
    role: OrganizationRole,
    familyMembersGroupTitle: string
  ): Array<any> => {
    const { onFamilyMemberClick } = this.props;

    return familyMembers.map((item) =>
      this.hasProfileRefresh() ? (
        <AccordionTextWithSubtextItem
          key={item.id}
          title={item.name}
          avatar={<UserAvatar user={item} />}
          subtext={familyMembersGroupTitle}
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          subtle
          onClick={() => onFamilyMemberClick && onFamilyMemberClick(item, role)}
        />
      ) : (
        <AvatarWithTextItem
          key={item.id}
          title={item.name}
          avatar={<UserAvatar user={item} />}
          subtext={familyMembersGroupTitle}
          subtle
          onClick={() => onFamilyMemberClick && onFamilyMemberClick(item, role)}
        />
      )
    );
  };

  render = () => {
    const { familySummary } = this.props;

    const familyMembers = familySummary.parents.concat(familySummary.children);
    const cappedFamilyMembers = familyMembers.slice(0, this.props.maxProfilePics);
    const overflowFamilyMembers = familyMembers.slice(this.props.maxProfilePics);

    if (this.props.orientation === 'vertical') {
      return (
        <div className="GroupMemberFamilyList">
          <AvatarWithTextItems>
            {this.renderVerticalFamilyMembersGroup(
              familySummary.parents,
              OrganizationRole.parent,
              'Parent'
            )}
            {this.renderVerticalFamilyMembersGroup(
              familySummary.children,
              OrganizationRole.student,
              'Child'
            )}
          </AvatarWithTextItems>
        </div>
      );
    }

    return (
      <React.Fragment>
        {cappedFamilyMembers.map(this.renderProfilePicture)}
        {overflowFamilyMembers.length > 0 && (
          <HoverLayerTrigger
            alignment="middle"
            placement="bottom"
            layer={
              <Tooltip>
                {overflowFamilyMembers.map((mem: any, index: number) => (
                  // in theory this should come from
                  // src/users/components/UsersProfile/UsersProfile.tsx
                  // but who knows
                  <p key={index}>{mem?.name}</p>
                ))}
              </Tooltip>
            }
          >
            <Coin color="whiteout" border="mascot" size="xxxlarge">
              +{overflowFamilyMembers.length}
            </Coin>
          </HoverLayerTrigger>
        )}
      </React.Fragment>
    );
  };
}
